export const TaskTracker = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_300_3664)">
      <path
        d="M9.33333 1.75C9.33333 0.785167 8.54817 0 7.58333 0H1.75C0.785167 0 0 0.785167 0 1.75V11.9583C0 13.0842 0.915833 14 2.04167 14H9.33333C10.2982 14 11.0833 13.2148 11.0833 12.25V10.5H9.33333V1.75ZM9.91667 11.6667V12.25C9.91667 12.572 9.65533 12.8333 9.33333 12.8333H3.88617C4.01275 12.5679 4.08333 12.271 4.08333 11.9583V11.6667H9.91667ZM2.91667 10.5V11.9583C2.91667 12.4407 2.52408 12.8333 2.04167 12.8333C1.55925 12.8333 1.16667 12.4407 1.16667 11.9583V1.75C1.16667 1.428 1.428 1.16667 1.75 1.16667H7.58333C7.90533 1.16667 8.16667 1.428 8.16667 1.75V10.5H2.91667ZM12.25 0C11.2852 0 10.5 0.785167 10.5 1.75V8.9915L12.25 10.7415L14 8.9915V1.75C14 0.785167 13.2148 0 12.25 0ZM12.8333 8.5085L12.25 9.09183L11.6667 8.5085V1.75C11.6667 1.428 11.928 1.16667 12.25 1.16667C12.572 1.16667 12.8333 1.428 12.8333 1.75V8.5085ZM5.01783 2.50425L5.84267 3.32908L4.19358 4.97817C4.01275 5.159 3.77533 5.24942 3.53792 5.24942C3.3005 5.24942 3.06308 5.159 2.88225 4.97817L1.9215 4.01742L2.74633 3.19258L3.53792 3.98417L5.01783 2.50425ZM5.01783 6.00425L5.84267 6.82908L4.19358 8.47817C4.01275 8.659 3.77533 8.74942 3.53792 8.74942C3.3005 8.74942 3.06308 8.659 2.88225 8.47817L1.9215 7.51742L2.74633 6.69258L3.53792 7.48417L5.01783 6.00425Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_300_3664">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
